import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux'
import './style.css'
import { faCheck, faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { logo } from '../../assets'
import { colors } from '../../colors'
import { Button } from '../../components/button'
import Spinner from '../../components/spinner';

// import { register } from '../../slices/auth'
import { register, reset } from '../../pages/features/auth/authSlice'


    const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
    const FIRSTNAME_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
    const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!-@#$%]).{8,}$/;
    const EMAIL_REGEX = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;



const SignUp = () => {

    
    

    const userRef = useRef()
    // const lastnameRef = useRef()
    const errRef = useRef()

    


    const [userFirstName, setUserFirstName] = useState('')
    const [validFirstName, setValidFirstName] = useState(false)
    const [firstNameFocus, setFirstNameFocus] = useState(false)

    const [userLastName, setUserLastName] = useState('')
    const [validLastName, setValidLastName] = useState(false)
    const [lastNameFocus, setLastNameFocus] = useState(false)

    const [userEmail, setUserEmail] = useState('')
    const [validEmail, setValidEmail] = useState(false)
    const [emailFocus, setEmailFocus] = useState(false)

    const [userPassword, setUserPassword] = useState('')
    const [validPassword, setValidPassword] = useState(false)
    const [passwordFocus, setPasswordFocus] = useState(false)

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    
    const [successful, setSuccessful] = useState(false);
    const [loading, setLoading] = useState(false);
    // const { message } = useSelector(state => state.message);
    const { user, isLoading, isError, isSuccess, message } = useSelector(state => state.auth);

    const navigate = useNavigate()
    const dispatch = useDispatch();

    useEffect(() => {
        userRef.current.focus();
    }, []);




    useEffect(() => {

        const result = FIRSTNAME_REGEX.test(userFirstName);
        setValidFirstName(result);
    })

    useEffect(() => {

        const result = USER_REGEX.test(userLastName);
        setValidLastName(result);
    })

    useEffect(() => {

        const result = EMAIL_REGEX.test(userEmail);
        setValidEmail(result);
    })

    useEffect(() => {

        const result = PWD_REGEX.test(userPassword)
        setValidPassword(result);

    });

    useEffect(() => {
        setErrMsg('');
    }, [userFirstName, userLastName, userEmail, userPassword]);

    useEffect(() => {
        if (isError){
            toast.error(message);
        }

        if (isSuccess || user){
            // toast.success(message);
            navigate('/login');
        }
        dispatch(reset());

    }, [user, isError, isSuccess, message, navigate, dispatch]);

    const onSubmit = (data) => {
        data.preventDefault();

        if (
            userFirstName === "" ||
            userLastName === "" ||
            userEmail === "" ||
            userPassword === ""
          ) {
            toast.error("Please fill all the fields", {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
            
          }else{
            const userData = {
                userFirstName,
                userLastName,
                userEmail,
                userPassword
            }
            dispatch(register(userData))
          }

    };

    if (isLoading) {
        return <Spinner />; 
    }

    

  return (
    <Container>
        <NavBar/>
        <p ref={errRef} className={errMsg ? 'errmsg' : 'offscreen'} > </p>

        <form onSubmit={onSubmit} >
            <img src={logo} alt="" />
            <h1>Create an account</h1>
            <p>Join National Virtual Library</p>
            
            <InputContainer>
                <label htmlFor="firstName">First Name*
                    <FontAwesomeIcon icon={faCheck} className={validFirstName ? "valid" : "hide"} />
                    <FontAwesomeIcon icon={faTimes} className={validFirstName || !userFirstName ? "hide" : "invalid"} />
                </label>
                <input 
                    name='userFirstName' 
                    value={userFirstName} 
                    type="text" 
                    placeholder='First Name'
                    onChange={(e) =>setUserFirstName(e.target.value) }
                    aria-invalid={ validFirstName ? 'false' : 'true'}
                    aria-describedby='uidnote'
                    // required 
                    id='userFirstName'
                    ref={userRef}
                    autoComplete='off'
                    onFocus={() => setFirstNameFocus(true)}
                    onBlur={() => setFirstNameFocus(false)}
                    />

                <p id='uidnote' className={firstNameFocus && userFirstName && !validFirstName ? 'instructions' : 'offscreen'}> 
                    <FontAwesomeIcon icon={faInfoCircle} />
                    <span>First name must be at least 4 characters long and must not contain special characters</span>
                </p>
            </InputContainer>

            <InputContainer>
                <label htmlFor="userLastName">Last Name*

                    <FontAwesomeIcon icon={faCheck} className={validLastName ? "valid" : "hide"} />
                    <FontAwesomeIcon icon={faTimes} className={validLastName || !userLastName ? "hide" : "invalid"} />
                </label>
                <input 
                    name='userLastName' 
                    value={userLastName} 
                    type="text" 
                    placeholder='Last Name'
                    onChange={(e) =>setUserLastName(e.target.value) } 
                    // required 
                    aria-invalid={ validLastName ? 'false' : 'true'}
                    aria-describedby='uidnote' 
                    id='userLastName'
                    // ref={lastnameRef}
                    autoComplete='off'
                    onFocus={() => setLastNameFocus(true)}
                    onBlur={() => setLastNameFocus(false)}
                />

                <p id='uidnote' className={lastNameFocus && userLastName && !validLastName ? 'instructions' : 'offscreen'}> 
                    <FontAwesomeIcon icon={faInfoCircle} />
                    <span>Last name must be at least 4 characters long and must not contain special characters</span>
                </p>
            </InputContainer>

            <InputContainer>
                <label htmlFor="name">Email*
                
                    <FontAwesomeIcon icon={faCheck} className={validEmail ? "valid" : "hide"} />
                    <FontAwesomeIcon icon={faTimes} className={validEmail || !userEmail ? "hide" : "invalid"} />

                </label>
                <input 
                    name='userEmail' 
                    value={userEmail}  
                    type="email" 
                    id='userEmail'
                    placeholder='Enter your email' 
                    onChange={(e) =>setUserEmail(e.target.value) } 
                    // required 
                    aria-invalid={validEmail ? "false" : "true"}
                    aria-describedby="uidnote"
                    onFocus={() => setEmailFocus(true)}
                    onBlur={() => setEmailFocus(false)}

                
                />
            </InputContainer>

            {/* <InputContainer>
                <label htmlFor="number">Phone number</label>
                <input name='number' value={phoneNumber} type="text" placeholder='Enter your number'
                onChange={(e) =>setPhoneNumber(e.target.value) } />
            </InputContainer>
             */}
            <InputContainer>
                <label htmlFor="password">Password*
                    <FontAwesomeIcon icon={faCheck} className={validPassword ? "valid" : "hide"} />
                    <FontAwesomeIcon icon={faTimes} className={validPassword || !userPassword ? "hide" : "invalid"} />
                </label>
                <input 
                    name='userpassword' 
                    value={userPassword} 
                    type="password" 
                    id='userpassword'
                    placeholder='Create a password'
                    onChange={(e) =>{setUserPassword(e.target.value);} } 
                    // required 
                    aria-invalid={validPassword ? "false" : "true"}
                    aria-describedby="pwdnote"
                    onFocus={() => setPasswordFocus(true)}
                    onBlur={() => setPasswordFocus(false)}
                />
                {/* <small>Must be at least 8 characters.</small> */}

                <p id='uidnote' className={passwordFocus && userPassword && !validPassword ? 'instructions' : 'offscreen'}> 
                    <FontAwesomeIcon icon={faInfoCircle} />
                    <span>Password must contain at least 8 characters </span>
                    <div> <FontAwesomeIcon icon={faInfoCircle} /> Password must contain at least one digit (0-9) </div>
                    <div> <FontAwesomeIcon icon={faInfoCircle} /> Password must contain at least one uppercase (A-Z) and one lowercasr character (a-z)  </div>
                    <div>Allowed special characters: <span aria-label="exclamation mark">!</span> <span aria-label="dash">-</span> <span aria-label="at symbol">@</span> <span aria-label="hashtag">#</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span></div>
                </p>
            </InputContainer>

            <Button filled bgColor={'#2A870E'} noIcon text={'Get Started'} />
        </form>

        <small>Already have an account? <span> <Link to='/login'> Login</Link></span> </small>

    </Container>
  )
}

export const Container = styled.section`
    

    & > form{
        width: 80%;
        max-width: 320px;
        margin: 0 auto;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        /* Aligning the items in the center of the container. */
        /* align-items: center; */

        & > p{
            color: ${colors.faint_text};
            font-size: 16px;
            align-self: center;
        }

        & > img{
            width: 80px;
            height: 80px;
            margin: 0 auto;
            align-self: center;
        }

        & Button{
            width: 100% !important;
            height: 30px;
            margin-top: 20px;
        }

        & > h1{
            text-align: center;
            line-height: 30px;

            @media screen and ( max-width: 600px ) {
                
            }
        }

        & input {
            width: 100%;
        }
    }

    & > small{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 20px;

        & > span{
            color: ${colors.secondary};
            font-weight: 500;
        }

        & > a{
            display: flex;
            align-items: center;
            color: ${colors.faint_text};
            font-size: 14px;
            padding-left: 15px;
        }
    }

    & > span{
        color: ${colors.secondary};
        font-weight: 500;

        & a{
            color: ${colors.secondary};
        }

        & :hover{
            transition: 0.5s ease-in-out; 
            opacity: 0.7;
            /* color: #e5e5e5; */
        }
    }

    & h1{
        font-weight: 700;
    }
`

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    width: 100% !important;

    & label{
        font-size: 14px;
        margin-bottom: 5px;
        align-self: flex-start;
        font-weight: 500;
    }

    & input{
        border: 2px solid #D0D5DD;
        border-radius: 4px;
        height: 32px;
        padding: 0 10px;
        background-color: #fff;
        width: 100% !important;
    }

    & select{
        border: 2px solid #D0D5DD;
        border-radius: 4px;
        height: 32px;
        padding: 0 10px;
        background-color: #fff;
        width: 100% !important;
    }

    & small{
        text-align: left;
    }
`

export {SignUp}